/* 🤖 this file was generated by script */
export const wiconArrowLeft = {
  name: 'arrow_left',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 12H5m0 0l7 7m-7-7l7-7"/></svg>`,
};
